<template>
    <div class="avatar-container">
        <img class="avatar-img" :src="url" :style="{
            width: width + 'px',
            height: height + 'px'
        }">
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props: {
        url: {
            type: String,
            require: true
        },
        width: {
            type: Number,
            default: 150
        },
        height: {
            type: Number,
            default: 150
        }
    },
    computed: mapState('setting', ['data']),
    created() {
        this.$store.dispatch('setting/getData')
    }
}
</script>

<style scoped>
.avatar-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.avatar-img {
    border-radius: 50%;
    object-fit: cover;
    /* display: block;
    margin: 0 auto; */
}
</style>